export type ReatrementRecordType = {
  case_id: number;
  submitted: string;
  patient: string;
  physician: string;
  retreatment_id: number;
  patient_phone: number;
};
export type EOBsType = {
  id: number;
  claim_date: string;
  product: string;
  soc: string;
  insurance_name: string;
  insurance_type: string;
  practice_state:string;
  insurance_mac: string;
  billed: string;
  paid: string;
  allowed: string;
  created_date: string;
  coverage: string;
  redacted_file: boolean;
  insurance_state:string;
  cpt_codes: {
    billed: number;
    paid: number;
    allowed: number;
    copay:number;
  };
};
export type EOBsExcelFileType = {
  id: number;
  claim_date: string;
  product: string;
  soc: string;
  insurance_name: string;
  insurance_type: string;
  insurance_mac: string;
  practice_state:string;
  created_at: string;
  coverage: string;
  cpt_code: string;
  copay:string;
  billed: number;
  paid: number;
  allowed: number;
  specialty:string
};
export type EOBsReportAPIResponse = {
  data: EOBsExcelFileType[];
  status: 200;
  total_pages: 1;
};

export type EOBsAPIResponse = {
  data: EOBsType[];
  status: 200;
  total_pages: 1;
};

export type DeleteRetreatmentAPIRes = {
  message: string;
};
export type QueryParamsState = {
  date_from: string;
  date_to: string;
  insurance_name: string;
  pagination: boolean;
  page: number;
  sort_by: string;
  direction: "asc" | "desc";
  practice_state: string;
  insurance_type: string;
  product: string;
  cpt_codes: string;
  insurance_mac: string;
  doctor_taxonomy: string;
};

export enum QueryStateActions {
  CHANGE_FROM_DATE = "changeFromDate",
  CHANGE_TO_DATE = "changeToDate",
  CHANGE_INSURANCE_NAME = "changeInsuranceName",
  CLEAR_STATE = "clearState",
  CHANGE_PAGINATION_BIT = "changePaginationBit",
  CHANGE_PAGE = "changePage",
  CHANGE_SORT_PARAMS = "changeSortParams",
  CHANGE_PRACTICE_STATE = "changePracticeState",
  CHANGE_INSURANCE_TYPE = "changeInsuranceType",
  CHANGE_PRODUCT = "changeProduct",
  CHANGE_CPT_CODES = "changeCPTCodes",
  CHANGE_INSURANCE_MAC = "changeInsuranceMAC",
  CHANGE_DOCTOR_TAXONOMY = "changeDoctorTaxonomy",
}

export type QueryStateActionType =
  | {
      type: QueryStateActions.CHANGE_FROM_DATE;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_TO_DATE;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_INSURANCE_NAME;
      payload: string;
    }
  | {
      type: QueryStateActions.CLEAR_STATE;
    }
  | {
      type: QueryStateActions.CHANGE_PAGINATION_BIT;
      payload: boolean;
    }
  | {
      type: QueryStateActions.CHANGE_PAGE;
      payload: number;
    }
  | {
      type: QueryStateActions.CHANGE_SORT_PARAMS;
      payload: {
        sort_by: string;
        direction: "asc" | "desc";
      };
    }
  | {
      type: QueryStateActions.CHANGE_PRODUCT;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_PRACTICE_STATE;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_INSURANCE_TYPE;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_CPT_CODES;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_INSURANCE_MAC;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_DOCTOR_TAXONOMY;
      payload: string;
    };
